import { css } from '@emotion/css';

export const collapseCx = css`
  transition: margin ease-in-out 0.3s;
  &.MuiCollapse-hidden {
    display: none;
  }
`;

export const alertCx = css`
  padding: 0.5rem 0.75rem;

  background-color: #83a7fa;

  border: 1px solid #83a7fa;
  border-radius: 0.5rem;

  > .MuiAlert-icon {
    padding: 0;
    margin-right: 0.5rem;
  }

  .MuiSvgIcon-root {
    fill: #2656c6;
  }

  > .MuiAlert-message {
    padding: 0;
    color: #2656c6;
    font-size: 0.75rem;
    line-height: 17px;
  }

  > .MuiAlert-action {
    align-items: start;
  }
`;

export const newApplicationAlert = css`
  gap: 0.5rem;
  display: flex;
  align-items: start;
  margin-bottom: 1.5rem;
  justify-content: start;
  color: var(--colors-primary-30);
`;
